function initServiziGrid(grid) {
    const cards = Array.from(grid.querySelectorAll(".servizi__card"));

    if (cards.length < 2) {
        return;
    }

    function setActive(index) {
        cards.forEach((card, i) => card.classList.toggle("is-active", i === index));
    }

    cards.forEach((card, index) => {
        card.addEventListener("mouseenter", () => {
            grid.classList.add("is-interacting");
            setActive(index);
        });

        // Stesso stato di "interazione" anche per il focus da tastiera: senza
        // questo, chi naviga con Tab vede il testo (rivelato via CSS :focus)
        // ma non l'ingrandimento della card che un utente mouse ottiene in hover.
        card.addEventListener("focus", () => {
            grid.classList.add("is-interacting");
            setActive(index);
        });
    });

    grid.addEventListener("mouseleave", () => {
        grid.classList.remove("is-interacting");
        cards.forEach((card) => card.classList.remove("is-active"));
    });

    grid.addEventListener("focusout", (event) => {
        if (grid.contains(event.relatedTarget)) {
            return;
        }

        grid.classList.remove("is-interacting");
        cards.forEach((card) => card.classList.remove("is-active"));
    });
}

export function initServizi() {
    document.querySelectorAll("[data-servizi]").forEach(initServiziGrid);
}
